import { apiHandler } from '@/services/apiHandler';
import { internalAxios } from '@/services/axiosInstances';
import type { DutyFreeEventApiItem, DutyFreeEventListResponse } from '@/services/dto/event';
import { EVENT_ENDPOINTS } from '@/services/endpoints/event';
import type { ApiResponse } from '@/types/api';

export const getOffEvtList = async (): Promise<ApiResponse<DutyFreeEventApiItem[]>> => {
    const response = await apiHandler(async () => await internalAxios.post<DutyFreeEventListResponse>(EVENT_ENDPOINTS.OFF_EVT_LIST, {}));

    if (!response.ok || !response.data) {
        return response as ApiResponse<DutyFreeEventApiItem[]>;
    }

    const payload = response.data as unknown as DutyFreeEventListResponse;

    if (payload.resultCd !== '0') {
        throw {
            ok: false,
            error: payload.resultMsg ?? 'Failed to fetch event list',
            data: null,
        };
    }

    return {
        ok: true,
        data: payload.eventList ?? [],
    };
};
